export default "__VITE_ASSET__B34lZUOJ__"